import { useState, useRef, useCallback } from 'react';

type ConfirmDialogState = { open: boolean; message: string };

const CLOSED: ConfirmDialogState = { open: false, message: '' };

export function useConfirmDialog() {
  const [state, setState] = useState<ConfirmDialogState>(CLOSED);
  const resolveRef = useRef<((value: boolean) => void) | null>(null);

  const finish = (result: boolean) => {
    resolveRef.current?.(result);
    resolveRef.current = null;
    setState(CLOSED);
  };

  const request = useCallback(
    (message: string): Promise<boolean> =>
      new Promise((resolve) => {
        resolveRef.current = resolve;
        setState({ open: true, message });
      }),
    []
  );

  const confirm = () => finish(true);
  const cancel = () => finish(false);

  return { state, request, confirm, cancel };
}
